import {detail, list} from "@mc/mc-legacy";
import CiselnikApi from "../api/gen/cgo/CiselnikApi";

export const FIRMA_AREA = "firmaDetail";
export const SAZBY_DPH_LIST_AREA = "sazbyDphList";
export const NAKLADOVA_STREDISKA_LIST_AREA = "nakladovaStrediskaList";
export const DOPRAVCI_LIST_AREA = "dopravciList";
export const TERMIN_DOPRAVY_AREA = "terminDopravyDetail";
export const TERMINY_DOPRAVY_LIST_AREA = "terminyDopravyList";
export const TERMINY_DOPRAVY_OPERATOR_LIST_AREA = "terminyDopravyOperatorList";
export const ZPUSOBY_DOPRAVY_LIST_AREA = "zpusobyDopravyList";
export const ZPUSOBY_PLATBY_LIST_AREA = "zpusobyPlatbyList";
export const UKONY_LIST_AREA = "ukonyList";
export const SOUBOR_ATRIBUTY_LIST_AREA = "souborAtributyList";
export const POBOCKY_LIST_AREA = "pobockyList";
export const POBOCKY_NEVYDEJNI_LIST_AREA = "pobockyNevydejniList";
export const POBOCKY_UZIVATEL_LIST_AREA = "pobockyUzivatelList";
export const POBOCKY_OPERATOR_LIST_AREA = "pobockyOperatorList";
export const POBOCKA_AREA = "pobockaDetail";
export const ZPUSOB_PLATBY_AREA = "zpusobPlatbyDetail";
export const ZPUSOB_DOPRAVY_AREA = "zpusobDopravyDetail";

/**
 * Načtení údajů o společnosti.
 * @returns {Function}
 */
export function fetchFirmaIfNeeded() {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(FIRMA_AREA, "", () => {
            return CiselnikApi.getFirma();
        }));
    }
}

/**
 * Zneplatnění údajů o společnosti.
 * @returns {Function}
 */
export function invalidateFirma() {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(FIRMA_AREA, ""));
    }
}

/**
 * Načtení seznamu daňových sazeb.
 * @returns {Function}
 */
export function fetchSazbyDphIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SAZBY_DPH_LIST_AREA, null, (parent, filter) => {
            return CiselnikApi.getDane(filter.vcetneNeaktivnich ? null : false);
        }));
    }
}

/**
 * Filtrování daňových sazeb.
 * @param filter filtr
 * @returns {Function}
 */
export function filterSazbyDph(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(SAZBY_DPH_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu daňových sazeb.
 * @returns {Function}
 */
export function invalidateSazbyDph() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SAZBY_DPH_LIST_AREA));
    }
}

/**
 * Načtení seznamu nákladových středisek.
 * @returns {Function}
 */
export function fetchNakladovaStrediskaIfNeeded(naklStredId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(NAKLADOVA_STREDISKA_LIST_AREA, naklStredId, (parent) => {
            return CiselnikApi.getNaklStred(parent);
        }));
    }
}

/**
 * Zneplatnění seznamu nákladových středisek.
 * @returns {Function}
 */
export function invalidateNakladovaStrediska() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(NAKLADOVA_STREDISKA_LIST_AREA));
    }
}

/**
 * Načtení seznamu dopravců.
 * @returns {Function}
 */
export function fetchDopravciIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(DOPRAVCI_LIST_AREA, "", (parent, filter) => {
            return CiselnikApi.getDopravci(filter.vcetneNeaktivnich ? null : false);
        }));
    }
}

/**
 * Filtrování dopravců.
 * @param filter filtr
 * @returns {Function}
 */
export function filterDopravci(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(DOPRAVCI_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu dopravců.
 * @returns {Function}
 */
export function invalidateDopravci() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(DOPRAVCI_LIST_AREA));
    }
}

/**
 * Načtení termínu dopravy.
 * @param zpusobDopravaId ID způsobu dopravy
 * @param id ID termínu dopravy
 * @returns {Function}
 */
export function fetchTerminDopravyIfNeeded(zpusobDopravaId, id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(TERMIN_DOPRAVY_AREA, `${zpusobDopravaId}_${id}`, () => {
            return CiselnikApi.getTerminDopravy(zpusobDopravaId, id);
        }));
    }
}

/**
 * Zneplatnění termínu dopravy.
 * @param id ID termínu dopravy
 * @returns {Function}
 */
export function invalidateTerminDopravy(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(TERMIN_DOPRAVY_AREA, id));
    }
}

/**
 * Načtení seznamu termínů dopravy.
 * @returns {Function}
 */
export function fetchTerminyDopravyIfNeeded(zpusobDopravaId, datumDoruceni = null, force = false) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(TERMINY_DOPRAVY_LIST_AREA, `${zpusobDopravaId}_${datumDoruceni}`, (parent, filter) => {
            return CiselnikApi.getTerminyDopravy(zpusobDopravaId, filter.vcetneNeaktivnich ? null : false, datumDoruceni);
        }), force);
    }
}

/**
 * Filtrování termínů dopravy.
 * @param filter filtr
 * @returns {Function}
 */
export function filterTerminyDopravy(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(TERMINY_DOPRAVY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu termínů dopravy.
 * @returns {Function}
 */
export function invalidateTerminyDopravy() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(TERMINY_DOPRAVY_LIST_AREA));
    }
}

/**
 * Načtení seznamu termínů dopravy pro operátora.
 * @returns {Function}
 */
export function fetchTerminyDopravyOperatorIfNeeded(zpusobDopravaId, datumDoruceni = null, force = false) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(TERMINY_DOPRAVY_OPERATOR_LIST_AREA, `${zpusobDopravaId}_${datumDoruceni}`, (parent, filter) => {
            return CiselnikApi.getTerminyDopravy(zpusobDopravaId, filter.vcetneNeaktivnich ? null : false, datumDoruceni);
        }), force);
    }
}

/**
 * Zneplatnění seznamu termínů dopravy pro operátora.
 * @returns {Function}
 */
export function invalidateTerminyDopravyOperator() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(TERMINY_DOPRAVY_OPERATOR_LIST_AREA));
    }
}

/**
 * Načtení seznamu způsobů dopravy.
 * @returns {Function}
 */
export function fetchZpusobyDopravyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(ZPUSOBY_DOPRAVY_LIST_AREA, "", (parent, filter) => {
            return CiselnikApi.getZpusobyDopravy(filter.vcetneNeaktivnich ? null : false);
        }));
    }
}

/**
 * Filtrování způsobů dopravy.
 * @param filter filtr
 * @returns {Function}
 */
export function filterZpusobyDopravy(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(ZPUSOBY_DOPRAVY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu způsobů dopravy.
 * @returns {Function}
 */
export function invalidateZpusobyDopravy() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(ZPUSOBY_DOPRAVY_LIST_AREA));
    }
}

/**
 * Načtení seznamu způsobů platby.
 * @returns {Function}
 */
export function fetchZpusobyPlatbyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(ZPUSOBY_PLATBY_LIST_AREA, "", (parent, filter) => {
            return CiselnikApi.getZpusobyPlatby(null, filter.vcetneNeaktivnich ? null : false);
        }));
    }
}

/**
 * Filtrování způsobů platby.
 * @param filter filtr
 * @returns {Function}
 */
export function filterZpusobyPlatby(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(ZPUSOBY_PLATBY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu způsobů platby.
 * @returns {Function}
 */
export function invalidateZpusobyPlatby() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(ZPUSOBY_PLATBY_LIST_AREA));
    }
}

/**
 * Načtení seznamu úkonů.
 * @returns {Function}
 */
export function fetchUkonyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(UKONY_LIST_AREA, "", (parent, filter) => {
            return CiselnikApi.getUkony(filter.vcetneNeaktivnich);
        }));
    }
}

/**
 * Filtrování úkonů.
 * @param filter filtr
 * @returns {Function}
 */
export function filterUkony(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(UKONY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu úkonů.
 * @returns {Function}
 */
export function invalidateUkony() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(UKONY_LIST_AREA));
    }
}

/**
 * Načtení seznamu atributů souborů.
 * @returns {Function}
 */
export function fetchSouborAtributyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SOUBOR_ATRIBUTY_LIST_AREA, "", (parent, filter) => {
            return CiselnikApi.getSouborAtributy(filter.vcetneNeaktivnich ? null : false);
        }));
    }
}

/**
 * Filtrování atributů souborů.
 * @param filter filtr
 * @returns {Function}
 */
export function filterSouborAtributy(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(SOUBOR_ATRIBUTY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu atributů souborů.
 * @returns {Function}
 */
export function invalidateSouborAtributy() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SOUBOR_ATRIBUTY_LIST_AREA));
    }
}

/**
 * Načtení seznamu poboček.
 * @returns {Function}
 */
export function fetchPobockyIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(POBOCKY_LIST_AREA, "", (parent, filter) => {
            return CiselnikApi.getPobocky(filter.vcetneNeaktivnich ? null : false, false);
        }));
    }
}

/**
 * Načtení seznamu poboček.
 * @returns {Function}
 */
export function fetchPobockyNevydejniIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(POBOCKY_NEVYDEJNI_LIST_AREA, "", (parent, filter) => {
            return CiselnikApi.getPobocky(filter.vcetneNeaktivnich ? null : false, true);
        }));
    }
}

/**
 * Filtrování poboček.
 * @param filter filtr
 * @returns {Function}
 */
export function filterPobocky(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(POBOCKY_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu poboček.
 * @returns {Function}
 */
export function invalidatePobocky() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(POBOCKY_LIST_AREA));
    }
}

/**
 * Zneplatnění seznamu poboček.
 * @returns {Function}
 */
export function invalidatePobockyNevydejni() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(POBOCKY_NEVYDEJNI_LIST_AREA));
    }
}

/**
 * Načtení údajů o pobočce.
 * @param id ID pobočky
 * @returns {Function}
 */
export function fetchPobockaIfNeeded(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(POBOCKA_AREA, id, (parent) => {
            return CiselnikApi.getPobockaById(parent);
        }));
    }
}

/**
 * Zneplatnění údajů o pobočce.
 * @param id ID pobočky
 * @returns {Function}
 */
export function invalidatePobocka(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(POBOCKA_AREA, id));
    }
}

/**
 * Načtení údajů o způsobu platby.
 * @param id ID způsobu platby
 * @returns {Function}
 */
export function fetchZpusobPlatbyIfNeeded(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(ZPUSOB_PLATBY_AREA, id, (parent) => {
            return CiselnikApi.getZpusobPlatbyById(parent);
        }));
    }
}

/**
 * Zneplatnění údajů o způsobu platby.
 * @param id ID způsobu platby
 * @returns {Function}
 */
export function invalidateZpusobPlatby(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(ZPUSOB_PLATBY_AREA, id));
    }
}

/**
 * Načtení údajů o způsobu dopravy.
 * @param id ID způsobu dopravy
 * @returns {Function}
 */
export function fetchZpusobDopravyIfNeeded(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(ZPUSOB_DOPRAVY_AREA, id, (parent) => {
            return CiselnikApi.getZpusobDopravyById(parent);
        }));
    }
}

/**
 * Zneplatnění údajů o způsobu dopravy.
 * @param id ID způsobu dopravy
 * @returns {Function}
 */
export function invalidateZpusobDopravy(id) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(ZPUSOB_DOPRAVY_AREA, id));
    }
}

/**
 * Načtení seznamu výdejních míst pro uživatele.
 * @returns {Function}
 */
export function fetchPobockyUzivatelIfNeeded(idSpolecnost, idUzivatel) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(POBOCKY_UZIVATEL_LIST_AREA, idUzivatel, (parent) => {
            return CiselnikApi.getPobockyVydejSelect(idSpolecnost, parent);
        }));
    }
}

/**
 * Zneplatnění seznamu výdejních míst pro uživatele.
 * @returns {Function}
 */
export function invalidatePobockyUzivatel() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(POBOCKY_UZIVATEL_LIST_AREA));
    }
}

/**
 * Načtení seznamu poboček pro operátora.
 * @returns {Function}
 */
export function fetchPobockyOperatorIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(POBOCKY_OPERATOR_LIST_AREA, "", () => {
            return CiselnikApi.getPobockyOperatorSelect(null);
        }));
    }
}

/**
 * Zneplatnění seznamu poboček pro operátora.
 * @returns {Function}
 */
export function invalidatePobockyOperator() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(POBOCKY_OPERATOR_LIST_AREA));
    }
}
